import {HtmlHelper} from "../helpers/html.helper";

export class TimelineSizeCalculator {

    private static get _rootElement(): HTMLElement {
        return document.body.parentElement!;
    }

    public static calculate(element: HTMLElement | null, cellWidthMultiplication: number = 1): {
        numberOfColumns: number,
        numberOfRows: number,
        deltaY: number
    } {
        if (!element) {
            return {
                numberOfColumns: -1,
                numberOfRows: -1,
                deltaY: -1
            }
        }

        const cellWidth = this._getDefaultCellWidth(element);
        const {width, height} = TimelineSizeCalculator.getAvailableSpaceForCells(element);

        const numberOfColumns = Math.floor(width / (cellWidthMultiplication * cellWidth));
        // Use proper cellHeight for row calculation (was using cellWidth - bug!)
        const cellHeight = cellWidth; // Assuming square cells
        const numberOfRows = Math.floor(height / cellHeight);

        const deltaY = height - numberOfRows * cellHeight;
        HtmlHelper.setGlobalVar(`delta-y`, `${deltaY}px`);

        return {
            numberOfColumns,
            numberOfRows: numberOfRows + 1,
            deltaY
        };
    }

    public static getAvailableSpaceForCells(element: HTMLElement): { width: number, height: number } {
        const {width, height} = element.getBoundingClientRect();

        const headerWidth = getComputedStyle(TimelineSizeCalculator._rootElement).getPropertyValue('--project-header-width');
        const rowHeaderWidth = headerWidth.endsWith(`rem`)
            ? parseFloat(getComputedStyle(document.documentElement).fontSize) * parseFloat(headerWidth)
            : parseFloat(headerWidth) || 250;
        const mainToolbarHeight = parseFloat(getComputedStyle(TimelineSizeCalculator._rootElement).getPropertyValue('--main-toolbar-height'));

        return {
            width: width - rowHeaderWidth - 1,
            height: height - mainToolbarHeight - 1
        };
    }

    public static calculateCellWidth(element: HTMLElement | null, numbersOfColumns: number): number {
        if (!element) {
            return 0;
        }

        const cellWidth = this._getDefaultCellWidth(element);
        TimelineSizeCalculator._rootElement.style.setProperty('--cell-width', `${cellWidth}px`);

        return cellWidth;
    }

    public static calculateCellHeight(element: HTMLElement | null, numberOfRows: number): number {
        return 35;
        /*
        if (!element) {
            return 0;
        }

        const {height} = TimelineSizeCalculator.getAvailableSpaceForCells(element);
        const cellHeight = Math.floor(height / numberOfRows);

        TimelineSizeCalculator._rootElement.style.setProperty('--cell-height', `${cellHeight}px`);

        return cellHeight;
         */
    }

    private static _getDefaultCellWidth(element: Element): number {
        return Math.floor(parseInt(getComputedStyle(element).getPropertyValue('--cell-width-default').trim(), 10)) || 35
    }
}